import React from 'react';

// Utility to detect current theme
export const isDarkMode = (): boolean => {
  // Check if dark class is on html element (common pattern)
  if (document.documentElement.classList.contains('dark')) {
    return true;
  }
  
  // Check if dark class is on body element
  if (document.body.classList.contains('dark')) {
    return true;
  }
  
  // Check data-theme attribute
  const theme = document.documentElement.getAttribute('data-theme');
  if (theme === 'dark') {
    return true;
  }
  
  // Fallback to media query
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return true;
  }
  
  return false;
};

// Hook to get current theme
export const useTheme = () => {
  const [isDark, setIsDark] = React.useState(isDarkMode);
  
  React.useEffect(() => {
    const updateTheme = () => setIsDark(isDarkMode());
    
    // Listen for class changes on html element
    const observer = new MutationObserver(updateTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'data-theme']
    });
    
    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', updateTheme);
    
    return () => {
      observer.disconnect();
      mediaQuery.removeEventListener('change', updateTheme);
    };
  }, []);
  
  return isDark;
}; 